import { render, staticRenderFns } from "./BaseNavPage.vue?vue&type=template&id=92558730&scoped=true"
import script from "./BaseNavPage.vue?vue&type=script&lang=js"
export * from "./BaseNavPage.vue?vue&type=script&lang=js"
import style0 from "./BaseNavPage.vue?vue&type=style&index=0&id=92558730&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92558730",
  null
  
)

export default component.exports